import React from "react";

// New full logo asset (includes its own wordmark "Wynridge / Exterior Cleaning")
export const LOGO_URL = "/wynridge-logo.png?v=2";

/**
 * Logo
 * - `size` controls the height in px (the image is square; width auto)
 * - `onDark` adds a white rounded plate so the navy mark stays legible on
 *   dark backgrounds (sidebar, footer). When on light backgrounds we use
 *   mix-blend-multiply so the asset's own white background disappears.
 * - The asset already contains the wordmark, so we never render text here
 */
export default function Logo({ size = 96, onDark = false }) {
  if (onDark) {
    return (
      <div className="inline-flex items-center justify-center rounded-2xl bg-white px-3 py-2 shadow-sm">
        <img
          src={LOGO_URL}
          alt="Wynridge Exterior Cleaning"
          style={{ height: size, width: "auto" }}
          className="block select-none"
          draggable={false}
        />
      </div>
    );
  }
  return (
    <img
      src={LOGO_URL}
      alt="Wynridge Exterior Cleaning"
      style={{ height: size, width: "auto", mixBlendMode: "multiply" }}
      className="block select-none"
      draggable={false}
    />
  );
}
